import { render, staticRenderFns } from "./Pb3.vue?vue&type=template&id=1a5354a2&scoped=true"
import script from "./Pb3.vue?vue&type=script&lang=js"
export * from "./Pb3.vue?vue&type=script&lang=js"
import style0 from "./Pb3.vue?vue&type=style&index=0&id=1a5354a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5354a2",
  null
  
)

export default component.exports